'use client';

import { FC } from 'react';
import { SeoBlockStoryblok } from 'storyblok-types';
import { Image } from 'atoms/Image/Image';
import { H2, P } from 'atoms/Typography';
import { AccordionItems } from './AccordionItems';
import styles from './styles.module.css';

export const SeoBlock: FC<{ blok: SeoBlockStoryblok }> = ({ blok }) => {
  const { title, image, description, accordionItems } = blok;

  return (
    <div className={styles.root}>
      <H2 className={styles.headline}>{title}</H2>
      <div className={styles.wrapper}>
        <div className={styles.descriptionWrapper}>
          <div className={styles.imageWrapper}>
            <div className={styles.avatar}>
              <Image
                className={styles.image}
                src={image.filename}
                alt={title}
              />
            </div>
          </div>
          <div className={styles.copyWrapper}>
            <P className={styles.copyContent}>{description}</P>
          </div>
        </div>
        <AccordionItems items={accordionItems} />
      </div>
    </div>
  );
};
